import * as types from "./searchActionTypes";
import api from "./searchApi";

export function clearResults(model) {
  return {
    type: types.SEARCH_CLEAR_RESULTS,
    model,
  };
}

export function searchClients(
  page = 0,
  limit = 10,
  q = "",
  sortBy = ["client_fts.name:asc"],
) {
  return {
    type: types.SEARCH_CLIENTS,
    promise: api.searchClients(page, limit, q, sortBy),
    sortBy,
  };
}

export function searchMembers(
  page = 0,
  limit = 10,
  q = "",
  sortBy = [
  "members_client_fts.unaccented_member_first_name:asc",
  "members_client_fts.unaccented_member_last_name:asc",
],
  additionalFilters=[]
) {
  return {
    type: types.SEARCH_MEMBERS,
    promise: api.searchMembers(page, limit, q, sortBy, additionalFilters),
    sortBy,
  };
}

export function searchMembersForFollowUps(
  page = 0,
  limit = 10,
  q = "",
  sortBy = ["members_client_fts.member_first_name:asc;members_client_fts.member_last_name:asc"],
  additionalFilters=[]
) {
  return {
    type: types.SEARCH_MEMBERS,
    promise: api.searchMembersForFollowUps(page, limit, q, sortBy, additionalFilters),
    sortBy,
  };
}

export function updateSearch(searchString) {
  return {
    type: types.SEARCH_UPDATE_SEARCH,
    searchString,
    promise: Promise.resolve(),
  };
}

export function forceOpen() {
  return {
    type: types.SEARCH_FORCE_OPEN,
    promise: Promise.resolve(),
  };
}



// WEBPACK FOOTER //
// ./src/components/dashboard/search/searchActions.js